"use client";

import { useUserStore } from "@faire/retailer-visitor-shared/stores/domain/useUserStore";
import { HorizontalLine } from "@faire/web--source/slate/Layout/HorizontalLine";
import * as React from "react";

export const EmployeeColoredLine: React.FC = () => {
  const { isEmployee, isImpersonating } = useUserStore([
    "isEmployee",
    "isImpersonating",
  ]);

  if (isEmployee) {
    return <HorizontalLine width="full" color="blue" stroke="2px" />;
  }

  if (isImpersonating) {
    return <HorizontalLine width="full" color="lime" stroke="2px" />;
  }

  return null;
};
